import React, { Component } from 'react'
import { connect } from 'react-redux'
import ToggleSwitch from './ToggleSwitch'
import actions from '../actions/index'
import { currentUtcDateTime } from '../utils/dateTime'

class PortfolioAlertSwitch extends Component {
  state = {
    checked: this.props.defaultChecked
  }; 

  savePortfolioAlertPreference = (currentPortfolioAlert) => {    
    let portfolioPaddle = this.props.preferences.alertPreferences.find(element => element.id == this.props.id)
    let itemIndex = portfolioPaddle.portfolios.findIndex(x => x === this.props.portfolioId)   

    if (currentPortfolioAlert && itemIndex === -1) {
      portfolioPaddle.portfolios.push(Number(this.props.portfolioId))
    }
    if (!currentPortfolioAlert && itemIndex !== -1) {
      portfolioPaddle.portfolios.splice(itemIndex, 1)
    }

    let newPreferences = this.props.preferences.alertPreferences.map(
      element => element.id == this.props.id
        ? { ...element, portfolios: portfolioPaddle.portfolios, dateModified: currentUtcDateTime() }
        : element
    );

    const request = () => {      
      return {
        ...this.props.preferences,
        alertPreferences: newPreferences
      }
    }    
    this.props.onSubmit(request())
  }

  render () {    
    let portfolioAlertSwitchId = `tsPortfolioAlert${this.props.id}`
    let isEnabled = this.props.alertPreference.portfolios.findIndex(x => x === this.props.portfolioId) >= 0
    return (      
      <>
        <ToggleSwitch id={portfolioAlertSwitchId} Name={portfolioAlertSwitchId} defaultChecked={isEnabled} apiCallFunc={this.savePortfolioAlertPreference} text="Alerts"
        datagmupn='content'
        datagmuc='content_articlepage'
        datagmue='portfolio_instanttoggle'
        datagmua='click'
        contentTypeName={this.props.contentTypeName}
        contentTitle={this.props.contentTitle}
        areasOfInterest={this.props.areasOfInterest}/>
      </>
    )
  }
}

function mapStateToProps(state) {
  return {    
    preferences: state.userPreferences
  }
}

const mapDispatchToProps = (dispatch) => ({  
  onSubmit(request) {
    dispatch(actions.updatePreferences(request))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PortfolioAlertSwitch)
